import { useGetBreeds } from 'hooks/useGetBreeds';
import { useGetPetProfile } from 'hooks/useGetPetProfile';
import { useCountryCode } from 'petdna-lib-uicomponents/hooks';
import { useEffect } from 'react';
import { useStores } from 'stores/useStores';

import { TestState } from '../types/test-state.enum';

export const useGetHealthDashboardReport = () => {
  const { healthReportStore } = useStores();
  const { testsStore } = useGetPetProfile();
  const { breedStore } = useGetBreeds();
  const countryCode = useCountryCode(false);

  const { petProfile } = testsStore;
  const { breedResults } = breedStore;

  useEffect(() => {
    if (!breedResults
      || !countryCode
      || !petProfile
      || petProfile.testState === TestState.RECOLLECT
    ) return;
    healthReportStore.getHealthDashboardReport(
      petProfile,
      breedResults.breeds,
      countryCode,
    );
  }, [petProfile, breedResults, countryCode, healthReportStore]);

  return { healthReportStore, testsStore };
};
